import { BasicService } from './core/basic.service'

export class ImageService extends BasicService {

  static getList(start, size, path_type, action = 'listimage' ) {
    return this.http.get('/File_logic/upload', {start, size, path_type, action})
  }

  static deleteItem(id) {
    this.http.get('/File_logic/upload', {id, action: 'deletefile'});
  }
}